import { LoadIdView } from '../../../../models';

export class ShipmentLoadTransportOrdersLoad {
  public static readonly type = '[ShipmentLoadTransportOrders] Load';
  constructor(public payload: LoadIdView) {}
}

export class ShipmentLoadTransportOrdersInitialState {
  public static readonly type = '[ShipmentLoadTransportOrders] Set Initial State';
}
